import { render, staticRenderFns } from "./MyAccountHeader.vue?vue&type=template&id=0433b6dd&"
import script from "./MyAccountHeader.vue?vue&type=script&lang=ts&"
export * from "./MyAccountHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports